import { Navigate } from 'react-router-dom';
import AuthGuard from '../auth/AuthGuard';
import AuthOwnerGuard from '../auth/AuthOwnerGuard';
import { PATH_AFTER_LOGIN } from '../config-global';
import { PATH_DASHBOARD } from './paths';
import {
  DashboardLayout,
  OwnerDashboard,
  OwnerHorseListPage,
  OwnerTackListPage,
  OwnerWorkoutHorseListPage,
  UserAccountPage,
  EcommerceShopPage,
  EcommerceCheckoutPage,
  EcommerceProductDetailsPage,
  EcommerceSubscriptionShopPage,
  EcommerceSubscriptionDetailsPage,
  SubscriptionListPage,
  MyOrdersPage,
  WorkoutDetailsPage,
  EcommerceProductListPage,
  EcommerceProductEditPage,
  EcommerceProductCreatePage,
} from './elements';

const ownerDashboardRoute = {
  path: 'dashboard',
  element: (
    <AuthGuard>
      <AuthOwnerGuard>
        <DashboardLayout />
      </AuthOwnerGuard>
    </AuthGuard>
  ),
  children: [
    { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
    { path: 'app', element: <OwnerDashboard /> },
    {
      path: 'horse',
      children: [
        { element: <Navigate to="/dashboard/horse/" replace />, index: true },
        { path: PATH_DASHBOARD.horse.myhorses, element: <OwnerHorseListPage /> },
      ],
    },
    {
      children: [
        { path: PATH_DASHBOARD.ecommerce.list, element: <EcommerceShopPage /> },
        { path: PATH_DASHBOARD.ecommerce.checkout, element: <EcommerceCheckoutPage /> },
        { path: PATH_DASHBOARD.ecommerce.product, element: <EcommerceProductDetailsPage /> },
        {
          path: PATH_DASHBOARD.ecommerce.subscription,
          element: <EcommerceSubscriptionShopPage />,
        },
        {
          path: PATH_DASHBOARD.ecommerce.subscriptiondetail,
          element: <EcommerceSubscriptionDetailsPage />,
        },
        {
          path: 'e-commerce',
          children: [
            { element: <Navigate to={PATH_DASHBOARD.ecommerce.list} replace />, index: true },
            { path: 'list', element: <EcommerceProductListPage /> },
            { path: 'product/new', element: <EcommerceProductCreatePage /> },
            { path: 'product/:name', element: <EcommerceProductDetailsPage /> },
            { path: 'product/:name/edit', element: <EcommerceProductEditPage /> },
            { path: 'shop', element: <Navigate to={PATH_DASHBOARD.ecommerce.list} replace /> },
            {
              path: 'checkout',
              element: <Navigate to={PATH_DASHBOARD.ecommerce.checkout} replace />,
            },
          ],
        },
      ],
    },
    {
      path: 'track',
      children: [
        { element: <Navigate to="/dashboard/track/" replace />, index: true },
        { path: PATH_DASHBOARD.track.list, element: <OwnerTackListPage /> },
      ],
    },
    {
      path: 'workout',
      children: [
        { element: <Navigate to="/dashboard/workout/" replace />, index: true },
        { path: PATH_DASHBOARD.workout.list, element: <OwnerWorkoutHorseListPage /> },
        { path: PATH_DASHBOARD.workout.details, element: <WorkoutDetailsPage /> },
      ],
    },
    {
      path: 'user',
      children: [
        { element: <Navigate to="/dashboard/user/account" replace />, index: true },
        { path: 'account', element: <UserAccountPage /> },
      ],
    },
    {
      path: 'order',
      children: [{ path: PATH_DASHBOARD.order.list, element: <MyOrdersPage /> }],
    },
    {
      path: 'subscription',
      children: [{ path: PATH_DASHBOARD.subscription.list, element: <SubscriptionListPage /> }],
    },
  ],
};

export const ownerRoutes = [ownerDashboardRoute];
